import React from 'react'
import MyLeadsSearchSelectorDropdown from './searchSelectorDropdown'

const MyLeadsSearchSelector = (props) => {
  return (
      <MyLeadsSearchSelectorDropdown prevNextList={props.prevNextList} activeTab={props.activeTab}/>
  )
}

export default MyLeadsSearchSelector